export default class ExternalLinks {
  constructor() {
    this.links = document.querySelectorAll('a');
  }

  init() {
    [].forEach.call(this.links, link => {
      if (this._getExternal(link)) {
        this._setTarget(link);
      }
    });
  }

  /* eslint-disable class-methods-use-this */
  _getExternal(link) {
    // eslint-disable-line
    /**
     * NOTE: Due to a very inconsistent implementation of the link targets
     * checking the href attribute to decide if a link is external or not is
     * currently not feasable (or too cumbersome)
     */

    // const href = link.getAttribute('href');
    const rel = link.getAttribute('rel');

    // const protocol = new RegExp(/^https?/);
    // const host = new RegExp(`/${window.location.host}/`);
    // const mailto = new RegExp(/(^mailto)/);

    let external = false;

    if (rel != null && /(external)/.test(rel)) {
      external = true;
    }

    // if (protocol.test(href) && !host.test(href) && !mailto.test(href)) {
    //   external = true;
    // }

    return external;
  }
  /* eslint-enable class-methods-use-this */

  _setTarget(link) {
    // eslint-disable-line
    link.addEventListener('click', this._onClick.bind(this), false);
  }

  /* eslint-disable class-methods-use-this */
  _onClick(event) {
    // eslint-disable-line
    event.preventDefault();
    event.stopPropagation();

    const newWindow = window.open(event.target.getAttribute('href'), '_blank');
    newWindow.opener = null;
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/external_links.js